export default __webpack_public_path__ + "static/media/Screen Shot 2021-06-17 at 1.16.36 PM.ebab82f4.png";